import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

export default function getBuildingInfo(callback) {
    firebase
        .database()
        .ref('/kavtek_buildingInfo/' + PROJECT_CODE.projectCode)
        .on('value', (snapshot) => {
            callback(snapshot.val());
        });
}